import { Component, OnInit, Injectable, Input } from '@angular/core';
import { dataModel, Industry } from '../../../../models/data.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.sass']
})

// tslint:disable: no-string-literal
export class ButtonComponent implements OnInit {
  @Input() id: string;
  @Input() data: dataModel;

  constructor( private httpClient: HttpClient) {}

  ngOnInit() {
    this.data.PremiumIndustries.forEach((el) => {
      if (el.router === this.id) {
        this.id = el.routerID;
      }
    });
  }

  onLoadMore() {
    let size: number;
    let leght: number;
    this.httpClient.get(environment.doc + this.id).subscribe((data) => {
      this.data.PremiumIndustries.forEach((element) => {
        if ( element.routerID === this.id ) {
          size = element['data'].length;
          leght = data['fullCaseStudies'].length - size;
          if (leght > size) {
              for (let i = 0; i < 6; i++) {
                element['data'].push(data['fullCaseStudies'][size + i]);
              }
          } else {
            for (let i = 0; i < data['fullCaseStudies'].length; i++) {
              element['data'].push(data['fullCaseStudies'][data['fullCaseStudies'].length + i]);
            }
          }
        }
    });
  });
  }
}
